import React, { HTMLAttributes, useCallback, useEffect, useMemo, useState } from "react";
import { observer } from "mobx-react-lite";
import cx from "classnames";
import { useRouter } from "next/router";
import { Hooks } from "@xt/xtbase";
const { useTranslation } = Hooks;
import store from "store";
import Storage from "utils/storage";
import { routerPush } from "utils/method";

import { Popconfirm, Dropdown, MenuProps } from "antd";
import CMPT_btn from "./btn";

import styles from "./index.module.scss";

import { EtfConfigDataProps } from "store/market";

const EtfDropOrBtn: React.FC<{ cls: string; data: EtfConfigDataProps[] }> = ({ cls, data }) => {
  const router = useRouter();

  const dropdownItems: MenuProps["items"] = useMemo(() => {
    return data.map((obj) => {
      return {
        key: obj.dealPair,
        label: (
          <a onClick={() => routerPush(router, { symbol: obj.dealPair })}>
            <CMPT_btn doc={obj} />
          </a>
        ),
      };
    });
  }, []);

  if (data.length === 1) return <CMPT_btn onClick={() => routerPush(router, { symbol: data[0].dealPair })} className={cx(styles.btn, cls)} doc={data[0]} />;

  return (
    <Dropdown
      placement={"bottomRight"}
      getPopupContainer={(triggerNode: HTMLElement) => triggerNode}
      menu={{
        items: dropdownItems,
      }}
    >
      <div>
        <CMPT_btn className={cx("btnDrop", styles.btn, cls)} doc={data[0]} />
      </div>
    </Dropdown>
  );
};

const Main: React.FC<HTMLAttributes<HTMLDivElement>> = ({ className }) => {
  const t = useTranslation();
  // const router = useRouter();
  const { name, etfConfig } = store.market;

  const [isPop, setIsPop] = useState(false);
  const hidePop = useCallback(() => {
    Storage.set("isEtfGuideKnown", true);
    setIsPop(false);
  }, []);
  useEffect(() => {
    setIsPop(!Storage.get("isEtfGuideKnown"));
  }, []);

  const hasEtf = useMemo(() => {
    return !!(etfConfig && etfConfig[name] && etfConfig[name].data && etfConfig[name].data.length);
  }, [name, etfConfig]);
  const long2short = useMemo(() => {
    const long: EtfConfigDataProps[] = [];
    const short: EtfConfigDataProps[] = [];

    if (hasEtf && etfConfig) {
      etfConfig[name].data.map((obj) => {
        if (obj.multiple > 0) {
          long.push(obj);
        } else {
          short.push(obj);
        }
      });
    }

    long.sort((a, b) => b.multiple - a.multiple);
    short.sort((a, b) => a.multiple - b.multiple);

    const ary: { cls: string; data: EtfConfigDataProps[] }[] = [];
    long.length && ary.push({ cls: styles.long, data: long });
    short.length && ary.push({ cls: styles.short, data: short });

    return ary;
  }, [hasEtf, name, etfConfig]);

  if (!hasEtf) return <></>;
  return (
    <div className={cx(styles.main, className)}>
      {long2short.map((item, index) => {
        if (index === 0 && isPop)
          return (
            <Popconfirm
              key={name + "_" + index}
              title={t("trade.xGuideEtf", [name.split("_")[0].toUpperCase()])}
              getPopupContainer={(triggerNode: HTMLElement) => triggerNode}
              open={true}
              icon={null}
              showCancel={false}
              onConfirm={hidePop}
            >
              <EtfDropOrBtn cls={item.cls} data={item.data} />
            </Popconfirm>
          );
        return <EtfDropOrBtn key={name + "_" + index} cls={item.cls} data={item.data} />;
      })}
    </div>
  );
};

export default observer(Main);
